import Button from 'components/base/Button';
// import DatePicker from 'components/base/DatePicker';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import interceptor from 'services/interceptor';
import { Genre } from 'data/genres';
import { useNavigate } from 'react-router-dom';
import { Project } from '../../../data/projects';
//import { addProject } from '../../../services/project';
import openAIService from '../../../services/openai';

import { Budget } from 'data/budgets';
import NPSpinner from 'components/base/NPSpinner';
//import { setDate } from 'date-fns';

const CreateNew = () => {
  const navigate = useNavigate();
  const [genres, setGenres] = useState<Genre[]>([]);

  const [selectedTitle, setSelectedTitle] = useState('');
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [selectedBudget, setSelectedBudget] = useState('');
  const [selectedGenre, setSelectedGenre] = useState('');
  const [selectedYearSet, setSelectedYearSet] = useState('');
  const [selectedCharacters, setSelectedCharacters] = useState('');
  const [selectedOverview, setSelectedOverview] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [isWaiting, setIsWaiting] = useState(false);
  //const [completion, setCompletion] = useState('');
  const imageUrls = [
    'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_1_bg_img.jpg',
    'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_10_bg_img.jpg',
    'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_11_bg_img.jpg',
    'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_12_bg_img.jpg',
    'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_13_bg_img.jpg'
  ];

  const handleCreateButtonClick = async () => {
    const generateGuid = (): string => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    };

    const budget: Budget = {
      budgetId: generateGuid(),
      amount: parseFloat(selectedBudget),
      currency: selectedCurrency,
      type: 'Private Investment',
      notes: '',
      status: 'Awaiting Approval',
      isActive: true
    };

    const status: ProjectStatus = {
      statusId: generateGuid(),
      label: 'new',
      displayType: 'New'
    };

    const genre: Genre = {
      genreId: selectedGenre,
      genreName: genres.find(g => g.genreId === selectedGenre)?.genreName ?? '',
      isActive: true
    };

    function getRandomImageUrl(urls: string[]) {
      const randomIndex = Math.floor(Math.random() * urls.length);
      return urls[randomIndex];
    }

    const project: Project = {
      title: selectedTitle,
      budget: budget,
      genre: genre,
      yearSet: selectedYearSet,
      characters: selectedCharacters,
      briefOutline: selectedOverview,
      locations: selectedLocation,
      image: getRandomImageUrl(imageUrls),
      userId: localStorage.getItem('userId') || '',
      createdBy: localStorage.getItem('userId') || '',
      createdDate: new Date(),
      status: status
    };
    setIsWaiting(true);
    openAIService
      .postToOpenAI(project)
      .then(data => {
        if (data && data.length > 0) {
          navigate('/apps/project-management/project-details/' + data);
        } else {
          console.error('Error:', 'problem with returned project ID');
        }
        setIsWaiting(false);
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(() => {
        setIsWaiting(false);
      });
  };

  useEffect(() => {
    interceptor.apiWithAuth
      .get('/genre/get-all')
      .then(response => {
        setGenres(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  if (isWaiting) {
    return <NPSpinner />;
  }

  const allFieldsCompleted =
    selectedTitle &&
    selectedCurrency &&
    selectedBudget &&
    selectedGenre &&
    selectedYearSet &&
    selectedCharacters &&
    selectedOverview &&
    selectedLocation;

  return (
    <div>
      <h2 className="mb-4">Create a project</h2>
      <Row>
        <Col xs={12} xl={9}>
          <Row as="form" className="g-3 mb-6">
            <Col sm={6} md={8}>
              <FloatingLabel
                controlId="floatingInputGrid"
                label="Project title"
              >
                <Form.Control
                  type="text"
                  placeholder="Enter project name"
                  value={selectedTitle}
                  onChange={e => setSelectedTitle(e.target.value)}
                />
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel controlId="floatingSelectGenre" label="Genre">
                <Form.Select
                  value={selectedGenre}
                  onChange={e => setSelectedGenre(e.target.value)}
                >
                  <option>Select genre</option>
                  {genres.map((genre, index) => (
                    <option key={index} value={genre.genreId}>
                      {genre.genreName}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel
                controlId="floatingSelectCurrency"
                label="Currency"
              >
                <Form.Select
                  value={selectedCurrency}
                  onChange={e => setSelectedCurrency(e.target.value)}
                >
                  <option>Select currency</option>
                  <option value="GBP">GBP</option>
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="AUD">AUD</option>
                  <option value="CAD">CAD</option>
                  <option value="CHF">CHF</option>
                  <option value="CNY">CNY</option>
                  <option value="JPY">JPY</option>
                  <option value="NZD">NZD</option>
                  <option value="SEK">SEK</option>
                  <option value="NOK">NOK</option>
                  {/* Add other currencies here */}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel controlId="floatingSelectBudget" label="Budget">
                <Form.Select
                  value={selectedBudget}
                  onChange={e => setSelectedBudget(e.target.value)}
                >
                  <option>Select budget</option>
                  {[...Array(9)].map((_, index) => {
                    const minRange = (index + 1) * 1000000;
                    const maxRange = (index + 2) * 1000000;
                    return (
                      <option key={index} value={`${minRange}-${maxRange}`}>
                        {`${minRange / 1000000}-${maxRange / 1000000} Million`}
                      </option>
                    );
                  })}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel controlId="floatingInputGrid" label="Year set">
                <Form.Control
                  type="text"
                  placeholder="Year set"
                  value={selectedYearSet}
                  onChange={e => setSelectedYearSet(e.target.value)}
                />
              </FloatingLabel>
            </Col>
            {/* <Col sm={6} md={4}>
              <FloatingLabel controlId="floatingSelectTeam" label="Team">
                <Form.Select>
                  <option>Select team</option>
                  <option value="1">Team One</option>
                  <option value="2">Team Two</option>
                  <option value="3">Team Three</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel controlId="floatingSelectAssignees" label="People">
                <Form.Select>
                  <option>Select assignees</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel
                controlId="floatingSelectAdmin"
                label="Project Lead"
              >
                <Form.Select>
                  <option>Select admin</option>
                  <option value="1">Data Privacy One</option>
                  <option value="2">Data Privacy Two</option>
                  <option value="3">Data Privacy Three</option>
                </Form.Select>
              </FloatingLabel>
            </Col> */}
            {/* <Col sm={6} md={4}>
              <DatePicker
                options={{
                  enableTime: false,
                  dateFormat: 'Y-m-d H:i',
                  defaultDate: selectedStartDate
                }}
                onChange={([date]) => {
                  setSelectedStartDate(date.toISOString().split('T')[0]);
                }}
                render={(_, ref) => {
                  return (
                    <Form.Floating className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Start date"
                        ref={ref}
                        id="startDate"
                      />
                      <label htmlFor="startDate" className="ps-6">
                        Start date
                      </label>
                    </Form.Floating>
                  );
                }}
              />
            </Col>
            <Col sm={6} md={4}>
              <DatePicker
                options={{
                  enableTime: false,
                  dateFormat: 'Y-m-d H:i',
                  defaultDate: selectedDeadline
                }}
                onChange={([date]) => {
                  setSelectedDeadline(date.toISOString().split('T')[0]);
                }}
                render={(_, ref) => {
                  return (
                    <Form.Floating className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Deadline"
                        ref={ref}
                        id="dealine"
                      />
                      <label htmlFor="deadline" className="ps-6">
                        Deadline
                      </label>
                    </Form.Floating>
                  );
                }}
              /> 
            </Col> */}
            <Col xs={12} className="gy-6">
              <FloatingLabel controlId="floatingCharacters" label="Characters">
                <Form.Control
                  as="textarea"
                  placeholder="Characters"
                  style={{ height: '100px' }}
                  value={selectedCharacters}
                  onChange={e => setSelectedCharacters(e.target.value)}
                />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="gy-6">
              <FloatingLabel
                controlId="floatingProjectOverview"
                label="Project overview"
              >
                <Form.Control
                  as="textarea"
                  placeholder="Overview"
                  style={{ height: '100px' }}
                  value={selectedOverview}
                  onChange={e => setSelectedOverview(e.target.value)}
                />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="gy-6">
              <FloatingLabel controlId="floatingLocation" label="Location">
                <Form.Control
                  as="textarea"
                  placeholder="Location"
                  style={{ height: '100px' }}
                  value={selectedLocation}
                  onChange={e => setSelectedLocation(e.target.value)}
                />
              </FloatingLabel>
            </Col>
            {/* <Col md={6} className="gy-6">
              <FloatingLabel controlId="floatingSelectClient" label="Client">
                <Form.Select>
                  <option>Select client</option>
                  <option value="1">Client One</option>
                  <option value="2">Client Two</option>
                  <option value="3">Client Three</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col md={6} className="gy-6">
              <FloatingLabel controlId="floatingInputBudget" label="Budget">
                <Form.Control type="text" placeholder="Budget" />
              </FloatingLabel>
            </Col> */}
            {/* <Col xs={12} className="gy-6">
              <ReactSelect
                isMulti
                placeholder="Add tags"
                options={[
                  { value: 'Biology', label: 'Biology' },
                  { value: 'Brainlessness', label: 'Brainlessness' },
                  { value: 'Jerry', label: 'Jerry' },
                  { value: 'Neurology', label: 'Neurology' },
                  { value: 'Not_the_mouse', label: 'Not_the_mouse' },
                  { value: 'Rick', label: 'Rick' },
                  { value: 'Stupidity', label: 'Stupidity' }
                ]}
                classNames={{
                  control: () => 'py-3',
                  valueContainer: () => 'lh-1'
                }}
              />
            </Col> */}
            <Col xs={12} className="gy-4">
              <div className="d-flex justify-content-end gap-3">
                <Button
                  variant="phoenix-primary"
                  className="px-5"
                  onClick={() => handleCreateButtonClick()}
                  disabled={!allFieldsCompleted}
                >
                  Create
                </Button>
                <Button
                  variant="phoenix-primary"
                  className="px-5"
                  onClick={() =>
                    navigate('/apps/project-management/project-board-view')
                  }
                >
                  Cancel
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default CreateNew;
